/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { getPayloadObject, getTelemetryAttributes, IPayLoad, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import Cookies from 'universal-cookie';

export interface ICookieComplianceRejecttButton {
    rejectCookiesButtonText?: string;
    rejectCookiesButtonAriaLabel?: string;

    /**
     * The telemetry content
     */
    telemetryContent?: ITelemetryContent;
    onClose(): void;
    cookies?: Cookies | undefined;
}

export const CookieComplianceRejectButton: React.FC<ICookieComplianceRejecttButton> = ({
    rejectCookiesButtonText,
    rejectCookiesButtonAriaLabel,
    telemetryContent,
    onClose,
    cookies
}) => {
    const payLoad: IPayLoad = getPayloadObject('click', telemetryContent!, 'reject cookies');
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);
    const handleReject = () => {
        if (!cookies?.get('accept')) {
            cookies?.set('reject', true);
        }
        onClose();
    };
    return (
        <button
            type='button'
            className='ms-cookie-compliance__reject-button msc-btn'
            aria-label={rejectCookiesButtonAriaLabel}
            onClick={handleReject}
            {...attributes}
        >
            {rejectCookiesButtonText}
        </button>
    );
};
